module.exports = __webpack_public_path__ + "img/imagen_becas.a8992f13.jpg";